import authenticate from '@/middleware/authenticate'
import store from '@/store'

export default [
  {
    path: '/payslips',
    name: 'payslip',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/payslip/index.vue'),
    beforeEnter: async (to, from, next) => {
      await Promise.all([store.dispatch('hr/payslip/fetchTemplates'), store.dispatch('hr/payslip/fetchEmployees')])

      next()
    }
  }
]
